module.exports = __webpack_public_path__ + "static/media/dental-crown.7ca004fb.svg";